import type { Staff } from '@/features/companies/types/department.types';

import apiClient from '@/axios/app-client';

// API endpoint constant
const STAFFS_ENDPOINT = '/v1/staffs';

export interface GetStaffsParams {
  role_key?: string;
  department_id?: string;
  [key: string]: unknown;
}

export const staffsService = {
  /**
   * Get staffs with optional filtering by role and department
   * @param params - Query parameters (role_key, department_id, etc.)
   * @returns Promise with array of staffs
   */
  getStaffs: async (params: GetStaffsParams = {}) => {
    const response = await apiClient.get<Staff[]>(STAFFS_ENDPOINT, params);
    return response.data.data;
  },
};
